import axios from 'axios';

const axiosCall = axios.create({
    // 172.20.10.2
    baseURL: "http://172.20.10.2:9000/api/v1/furniture"
})

export default axiosCall;